/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CountryCodeEnum } from '../../models/country-code-enum';

export interface LanguageSet$Params {
  productId: string;
  index: number;
  language?: CountryCodeEnum;
}

export function languageSet(http: HttpClient, rootUrl: string, params: LanguageSet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, languageSet.PATH, 'post');
  if (params) {
    rb.path('productId', params.productId, {});
    rb.path('index', params.index, {});
    rb.query('language', params.language, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

languageSet.PATH = '/api/Language/{productId}/{index}';
